import React, { useEffect, useState } from "react";
import { Row } from "reactstrap";
import nCount from "../assets/ncount.png";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
function Login() {
  const navigate = useNavigate();
  const [mobile, setMobile] = useState(null);
  const [password, setPassword] = useState(null);
  const [isLoadingTrue, setLoadingTrue] = useState(false);
  const [error, setError] = useState(null);
  const handleLogin = async () => {
    setLoadingTrue(true);
    await axios
      .post("https://507pnzkkhc.execute-api.us-east-1.amazonaws.com/auth", {
        mobile,
        password,
      })
      .then((resp) => {
        console.log(resp?.data?.body);
        if (resp?.data?.body?.msg == "Success") {
          localStorage.setItem("Mobile", resp?.data?.body?.data[0]?.mobile);
          localStorage.setItem("enumerator_id",resp?.data?.body?.data[0]?.id);
          localStorage.setItem("name",resp?.data?.body?.data[0]?.name);
          localStorage.setItem("mobile_model",resp?.data?.body?.data[0]?.mobile_model);
          localStorage.setItem("odkToken",resp?.data?.body?.data[0]?.odkToken);
          navigate("/dashboard");
        } else {
          setError(resp?.data?.body);
        }
        setLoadingTrue(false);
      })
      .catch((err) => {
        console.log(err);
        setLoadingTrue(false);
      });
  };
  useEffect(() => {
    if (localStorage.getItem("Mobile")) {
      navigate("/dashboard");
    }
  }, []);
  return (
    <div>
      <Row className="home-main-row">
        <div className="home-main-div">
          <img src={nCount} className="ncount-image mb-5" />
          <h4 className="home-main-heading">
            Rice Fallow Management Baseline Survey
          </h4>
          {/* <p >Sign In</p> */}
          <input
            className="login-input mt-5"
            onChange={(e) => setMobile(e.target.value)}
            placeholder="Username"
          />
          <input
            className="login-input"
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
          />
          {/* <Link to="/dashboard"> */}
          <button
            className="home-button mt-3 mb-2"
            onClick={() => handleLogin()}
          >
            {isLoadingTrue ? "Loading..." : " Log in "}
          </button>
          <p style={{ color: "red", fontSize: 10 }}>{error}</p>
          {/* </Link> */}
        </div>
      </Row>
    </div>
  );
}

export default Login;
